import { Chip } from '@mui/material';
import { useCaseFieldData } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';

const DocumentCountChip: React.FC<{ mode: FieldMode }> = ({ mode }) => {
  const data = useCaseFieldData(mode);

  return <Chip label={`${data.documentCount} uploaded`} size="small" />;
};

export default DocumentCountChip;